
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/winners",
      function () {
        return require("private-next-pages/shop/winners.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/winners"])
      });
    }
  